import type { UndecoratedTreatment } from '@witmetrics/utils';
import { isBlank } from '@witmetrics/utils/strings';

export function formatTreatmentLabel({
  name,
  description,
}: Pick<UndecoratedTreatment, 'name' | 'description'>) {
  return isBlank(description) ? name : `${name} (${description})`;
}
